import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import lockImg from '../../../animation/Hero/private_lock.svg';
import UnlockImg from '../../../animation/Hero/public_unlock.svg';
import { store } from "../../../redux/store";
import styles from "./css/CreateNewCourseCard.module.css";

const CreateNewCourseCard = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(false);
  const [openTypeModal, setOpenTypeModal] = useState(false);
  const [selectedCourseType, setSelectedCourseType] = useState(null);
  const [selectedMode, setSelectedMode] = useState(null);

  const userType = store.getState().profile.user;

  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCloseTypeModal = () => setOpenTypeModal(false);

  const handleSelectRecorded = () => setSelectedMode("recorded");
  const handleSelectLive = () => setSelectedMode("live");

  const handleOpenTypeModal = () => {
    setSelectedCourseType(null);
    if (userType?.user_type === "INDIVIDUAL") {
      setSelectedCourseType("Public");
      setOpen(true);
    }
    else {
      setOpenTypeModal(true)

    }
  }

  const handleNext = () => {
    if (!selectedMode) return;
    history.push("/course/create", {
      courseTitleType: "Create",
      courseType: selectedCourseType,
      courseMode: selectedMode,
    });
    handleClose();
    setSelectedMode(null);
    setSelectedCourseType(null);
  };

  const handleNextType = () => {
    if (!selectedCourseType) return;
    setOpenTypeModal(false);
    setOpen(true);
  };
  const desktopPaperStyle = { borderRadius: 32, padding: 12, width: 658 };
  const mobilePaperStyle = { ...desktopPaperStyle, margin: 12, maxWidth: "95vw", width: "auto" };

  return (
    <>
      <div className={styles.createCourseCard}>
        <div className={styles.createCourseContent} onClick={handleOpenTypeModal}>
          <div className={styles.createCourseIcon}>
            <AddIcon sx={{ width: "100%", height: "100%", color: "#fff" }} />
          </div>
          <p className={styles.createCourseText}>
            {t("courseMonetisation.createNewCourses", "Create New Courses")}
          </p>
        </div>
      </div>

      {/*Single Dialog: public vs private*/}
      <Dialog
        open={openTypeModal}
        onClose={handleCloseTypeModal}
        PaperProps={{ style: isMobile ? mobilePaperStyle : desktopPaperStyle }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: 46,
              height: 47,
              borderRadius: "10px",
              backgroundColor: "#F33070",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontWeight: 700,
            }}
          >
            <img
              style={{ width: 20, height: 20 }}
              src="/Image/CourseMonetisation/booklet-line-2.svg"
              alt=""
            />
          </Box>
          <span style={{ fontFamily: "Lato", fontWeight: 500, fontSize: "18px" }}>
            Create Course
          </span>
          <IconButton
            aria-label="close"
            onClick={handleCloseTypeModal}
            sx={{ marginLeft: "auto" }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid
            container
            spacing={3}
            sx={{
              width: isMobile ? "auto" : 550,
              maxWidth: isMobile ? "95vw" : "90vw",
              marginTop: 1,
            }}
          >
            {/* Public Course */}
            <Grid item xs={12} sm={6}>
              <Box
                onClick={() => setSelectedCourseType("Public")}
                sx={{
                  borderRadius: 4,
                  textAlign: "center",
                  cursor: "pointer",
                  p: 2,
                  border:
                    selectedCourseType === "Public"
                      ? "2px solid #F33070"
                      : "2px solid transparent",
                  boxShadow:
                    selectedCourseType === "Public"
                      ? "0 7px 20px rgba(0,0,0,0.16)"
                      : "0 5px 15px rgba(0,0,0,0.12)",
                  transition: "all 0.2s ease",
                  backgroundColor: "#fff",
                }}
              >
                {/* Lock Icon */}
                <img
                  src={UnlockImg}
                  alt="Public Course"
                  style={{ width: 80, height: 80 }}
                />

                {/* Title + Info icon */}
                <Box display="flex" alignItems="center" justifyContent="center" gap={0.5} mt={1}>
                  <Typography sx={{ fontWeight: 700, fontSize: 19.3664 }}>Public Course</Typography>
                  <Tooltip
                    title="Anyone can enroll into the course"
                    placement="top"
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: 'black',
                          color: 'white',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: '500',
                          padding: '8px 12px'
                        },
                      },
                      arrow: {
                        sx: {
                          color: 'black',
                        }
                      }
                    }}
                  >
                    <img
                      src="/Image/Icons/Iicon.svg"
                      alt="info"
                      style={{ width: 15, height: 15, cursor: "pointer" }}
                    />
                  </Tooltip>
                </Box>

                {/* Selection Circle */}
                <Box mt={1}>
                  {selectedCourseType === "Public" ? (
                    <Box
                      sx={{
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        border: "2px solid #F33070",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          backgroundColor: "#F33070",
                        }}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        border: "2px solid #000",
                        display: "inline-block",
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Private Course */}
            <Grid item xs={12} sm={6}>
              <Box
                onClick={() => setSelectedCourseType("Private")}
                sx={{
                  borderRadius: 4,
                  textAlign: "center",
                  cursor: "pointer",
                  p: 2,
                  border:
                    selectedCourseType === "Private"
                      ? "2px solid #F33070"
                      : "2px solid transparent",
                  boxShadow:
                    selectedCourseType === "Private"
                      ? "0 7px 20px rgba(0,0,0,0.16)"
                      : "0 5px 15px rgba(0,0,0,0.12)",
                  transition: "all 0.2s ease",
                  backgroundColor: "#fff",
                }}
              >
                <img
                  src={lockImg}
                  alt="Private Course"
                  style={{ width: 80, height: 80 }}
                />

                {/* Title + Info icon */}
                <Box display="flex" alignItems="center" justifyContent="center" gap={0.5} mt={1}>
                  <Typography sx={{ fontWeight: 700, fontSize: 19.3664 }}>Private Course</Typography>
                  <Tooltip
                    title="Course will be visible to invited users"
                    placement="top"
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: 'black',
                          color: 'white',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: '500',
                          padding: '8px 12px'
                        },
                      },
                      arrow: {
                        sx: {
                          color: 'black',
                        }
                      }
                    }}
                  >
                    <img
                      src="/Image/Icons/Iicon.svg"
                      alt="info"
                      style={{ width: 15, height: 15, cursor: "pointer" }}
                    />
                  </Tooltip>
                </Box>

                {/* Selection Circle */}
                <Box mt={1}>
                  {selectedCourseType === "Private" ? (
                    <Box
                      sx={{
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        border: "2px solid #F33070",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          backgroundColor: "#F33070",
                        }}
                      />
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        border: "2px solid #000",
                        display: "inline-block",
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Next Button */}
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: isMobile ? "center" : "flex-end" }}
            >
              <Button
                variant="contained"
                onClick={handleNextType}
                disabled={!selectedCourseType}
                sx={{
                  borderRadius: "60px",
                  fontFamily: "Montserrat,Arial,sans-serif",
                  background: "#F33070",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 700,
                  paddingX: 3,
                  textTransform: "none",
                  width: isMobile ? "100%" : "140px",
                  height: isMobile ? undefined : "45px",
                  opacity: selectedCourseType ? 1 : 0.6,
                }}
              >
                NEXT
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      {/* Single Dialog: Recorded vs Live */}
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ style: isMobile ? mobilePaperStyle : desktopPaperStyle }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              width: 46,
              height: 47,
              borderRadius: "10px",
              backgroundColor: "#F33070",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontWeight: 700,
            }}
          >
            <img style={{ width: 20, height: 20 }} src="/Image/CourseMonetisation/booklet-line-2.svg" alt="" />
          </Box>
          <span style={{ fontFamily: "Lato", fontWeight: 500, fontSize: "18px" }}>Create course</span>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{ marginLeft: "auto" }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid
            container
            spacing={3}
            sx={{ width: isMobile ? "auto" : 550, maxWidth: isMobile ? "95vw" : "90vw", marginTop: 1 }}
          >
            {/* STACK on mobile (xs=12), two-column on desktop (sm=6) */}
            <Grid item xs={12} sm={6}>
              {/* <Box
                onClick={handleSelectRecorded}
                sx={{
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: 2,
                }}
              > */}
              <img
                onClick={handleSelectRecorded}
                src={"/Image/CourseMonetisation/Recorded.png"}
                alt="Recorded course"
                loading="lazy"
                style={{
                  // height: isMobile ? 88 : 120,
                  width: "280px",
                  maxWidth: "100%",
                  objectFit: "contain",
                  display: "block",
                  borderRadius: 20,
                  border: selectedMode === "recorded" ? "2px solid #F33070" : "2px solid transparent",
                  boxShadow: selectedMode === "recorded" ? "0 7px 20px rgba(0,0,0,0.16)" : "0 5px 15px rgba(0,0,0,0.12)",
                  transition: "transform 180ms ease, box-shadow 180ms ease",
                }}
              />
              {/* </Box> */}
            </Grid>

            <Grid item xs={12} sm={6}>
              {/* <Box
                onClick={handleSelectLive}
                sx={{
                  borderRadius: 3,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: 2,
                }}
              > */}
              <img
                onClick={handleSelectLive}
                src={"/Image/CourseMonetisation/Live.png"}
                alt="Live course"
                loading="lazy"
                style={{
                  // height: isMobile ? 88 : 120,
                  width: "280px",
                  maxWidth: "100%",
                  objectFit: "contain",
                  display: "block",
                  borderRadius: 20,
                  border: selectedMode === "live" ? "2px solid #F33070" : "2px solid transparent",
                  boxShadow: selectedMode === "live" ? "0 7px 20px rgba(0,0,0,0.16)" : "0 5px 15px rgba(0,0,0,0.12)",
                  transition: "transform 180ms ease, box-shadow 180ms ease",
                }}
              />
              {/* </Box> */}
            </Grid>

            <Grid item xs={12} sx={{ display: "flex", justifyContent: isMobile ? "center" : "flex-end" }}>
              <Button
                variant="contained"
                onClick={handleNext}
                disabled={!selectedMode}
                sx={{
                  borderRadius: "60px",
                  fontFamily: "Montserrat,Arial,sans-serif",
                  background: "#F33070",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 700,
                  paddingX: 3,
                  textTransform: "none",
                  width: isMobile ? "100%" : "140px",
                  height: isMobile ? undefined : "45px",
                  opacity: selectedMode ? 1 : 0.6,
                }}
              >
                NEXT
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CreateNewCourseCard;
